import React from "react";
import { Image, Icon } from "atomize";

// import Images
import nextIcon from "../../assets/images/nextIcon.svg";
import previousIcon from "../../assets/images/previousIcon.svg";

// Next Icon
export const NextIcon = () => {
  return <Image src={nextIcon} w="25px" alt="nextIcons" />;
};

// Previous Icon
export const PreviousIcon = () => {
  return <Image src={previousIcon} w="25px" alt="previousIcon" />;
};

// Search Icon
export const SearchIcon = () => {
  return <Icon name="Search" size="20px" color="#C2CFE0" />;
};
